// ─────────────────────────────────────────────────
// EmailJS — configuracion via variables de entorno
// ─────────────────────────────────────────────────
export const EMAILJS_CONFIG = {
  serviceId:        import.meta.env.VITE_EMAILJS_SERVICE_ID,
  publicKey:        import.meta.env.VITE_EMAILJS_PUBLIC_KEY,
  templateAdminId:  import.meta.env.VITE_EMAILJS_TEMPLATE_ADMIN,
  templateClienteId:import.meta.env.VITE_EMAILJS_TEMPLATE_CLIENTE,
  adminEmail:       import.meta.env.VITE_EMAILJS_ADMIN_EMAIL,
}

const APP_URL = import.meta.env.VITE_APP_URL || "https://lowtravel.com"

async function getEmailJS() {
  try {
    const emailjs = await import("@emailjs/browser")
    return emailjs
  } catch {
    console.error("EmailJS no esta instalado. Correr: npm install @emailjs/browser")
    return null
  }
}

/**
 * EMAIL 1 — Recordatorio al admin (Sergio)
 * Se dispara al abrir el panel si hay viajes en las proximas 24hs
 * sin que el email ya haya sido enviado.
 */
export async function enviarEmailAdminCheckin({
  clienteNombre, destino, aerolinea,
  fechaSalida, fechaRegreso, hotel1, hotel2, pax, asistencia
}) {
  const emailjs = await getEmailJS()
  if (!emailjs) return false

  try {
    await emailjs.send(
      EMAILJS_CONFIG.serviceId,
      EMAILJS_CONFIG.templateAdminId,
      {
        admin_nombre:   "Sergio",
        admin_email:    EMAILJS_CONFIG.adminEmail,
        cliente_nombre: clienteNombre,
        destino:        destino      || "—",
        aerolinea:      aerolinea    || "—",
        fecha_salida:   fechaSalida  || "—",
        fecha_regreso:  fechaRegreso || "—",
        hotel1:         hotel1       || "—",
        hotel2:         hotel2       || "—",
        pax:            pax          || "—",
        asistencia:     asistencia   || "—",
        hora_envio:     new Date().toLocaleString("es-AR"),
      },
      EMAILJS_CONFIG.publicKey,
    )
    return true
  } catch (err) {
    console.error("Error enviando email admin:", err)
    return false
  }
}

/**
 * EMAIL 2 — Confirmacion al cliente
 * Se dispara cuando el admin toca "Confirmar check-in"
 */
export async function enviarEmailClienteCheckin({
  clienteNombre, clienteEmail, destino, aerolinea,
  fechaSalida, fechaRegreso, noches, pax, hotel1, hotel2, incluye, asistencia
}) {
  if (!clienteEmail) {
    console.warn("Cliente sin email registrado, no se puede enviar confirmacion.")
    return false
  }

  const emailjs = await getEmailJS()
  if (!emailjs) return false

  try {
    await emailjs.send(
      EMAILJS_CONFIG.serviceId,
      EMAILJS_CONFIG.templateClienteId,
      {
        cliente_nombre: clienteNombre,
        cliente_email:  clienteEmail,
        destino:        destino      || "—",
        aerolinea:      aerolinea    || "—",
        fecha_salida:   fechaSalida  || "—",
        fecha_regreso:  fechaRegreso || "—",
        noches:         noches       || "—",
        pax:            pax          || "—",
        hotel1:         hotel1       || "—",
        hotel2:         hotel2       || "—",
        incluye:        incluye      || "—",
        asistencia:     asistencia   || "—",
        url_panel:      `${APP_URL}/dashboard`,
      },
      EMAILJS_CONFIG.publicKey,
    )
    return true
  } catch (err) {
    console.error("Error enviando email cliente:", err)
    return false
  }
}